import { Button, Form, Input, notification, Space } from 'antd'
import { useForm } from 'antd/lib/form/Form'
import { Branches, BranchRentees, Images } from 'gadjet-v2-types/dist/model'
import { useEffect, useState } from 'react'

import mask from '@utils/mask'

import BranchAPI from '@apis/branch'

import HiddenItems from '@components/atoms/Form/HiddenItems'
import UploadButton from '@components/molecules/UploadButton'

type Props = { hqId: number; branchId: number; branch?: Branches; onRefresh: () => void }

export default function BranchRenteeForm({ hqId, branchId, branch, onRefresh }: Props): JSX.Element {
  const [form] = useForm<BranchRentees>()
  const [loading, setLoading] = useState(false)

  const onSubmit = async () => {
    const values = await form.validateFields()
    setLoading(true)
    await BranchAPI.updateBranchRentee({ hqId, branchId }, { rentee: values })
    setLoading(false)
    notification.success({ message: '저장되었습니다.' })
    onRefresh()
  }

  const onUploadSignatureImage = ({ imageId }: Images) => form.setFieldsValue({ signatureImageId: imageId })

  const resetForm = () => {
    form.resetFields()
    if (branch?.rentee) form.setFieldsValue(branch?.rentee)
  }

  useEffect(() => {
    resetForm()
  }, [branch])

  const initialValues: Partial<BranchRentees> = {
    name: '',
    businessNumber: '',
    corporationNumber: '',
    address: '',
    contact: '',
  }

  return (
    <Form form={form} layout="vertical" initialValues={initialValues}>
      <HiddenItems names={['signatureImageId', 'consentFileId']} />

      <Form.Item label="임대인 이름" name="name">
        <Input />
      </Form.Item>
      <Form.Item label="임대인 사업자번호" name="businessNumber" {...mask.businessLicense}>
        <Input />
      </Form.Item>
      <Form.Item label="임대인 법인번호" name="corporationNumber" {...mask.personalLicense}>
        <Input />
      </Form.Item>
      <Form.Item label="임대인 주소" name="address">
        <Input />
      </Form.Item>
      <Form.Item label="임대인 연락처" name="contact" {...mask.contact}>
        <Input />
      </Form.Item>

      <Form.Item shouldUpdate label="파일">
        {({ getFieldValue }) => {
          const signature = getFieldValue('signatureImage')
          return (
            <Space direction="vertical" style={{ width: '100%' }}>
              <UploadButton.Image
                category="signature"
                label="임대인 서명"
                accept="image/*"
                file={signature}
                onUploadDone={onUploadSignatureImage}
              />
            </Space>
          )
        }}
      </Form.Item>

      <Button type="primary" size="large" onClick={onSubmit} loading={loading}>
        저장하기
      </Button>
    </Form>
  )
}
